import { Injectable } from '@angular/core';
import {
  CanDeactivate,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { PrintStoryComponent } from 'app/+stories/print/print.component';
import { PrintService } from 'app/services/print.service';
import { FirebaseService } from 'app/services/firebase.service';

@Injectable()
export class CanDeactivatePrintFlow
  implements CanDeactivate<PrintStoryComponent> {
  constructor(
    private firebaseService: FirebaseService,
    private printService: PrintService
  ) {}

  public canDeactivate(
    component: PrintStoryComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): boolean {
    if (component.step !== 6) {
      const order = this.printService.printOrder;
      const specs = this.printService.specs;
      this.firebaseService.logEvent('checkout_cancel', {
        print_order_id: order.id,
        story_id: this.printService.storyId,
        project_id: this.printService.projectId,
      });
    }
    return true;
  }
}
